package org.multiplatform.kotfolio.styles

import org.multiplatform.kotfolio.models.Theme
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.anyLink
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.*

val NavigationItemStyle = CssStyle {
    base {
        Modifier
            .color(Theme.Secondary.rgb)
            .transition(Transition.of(property = "color", duration = 200.ms))
    }
    anyLink {
        Modifier.color(Theme.Secondary.rgb)
    }
    hover {
        Modifier.color(Theme.Primary.rgb)
    }
}

val LogoStyle = CssStyle {
    base {
        Modifier.transform { rotate(0.deg) }
            .transition(Transition.of(property = "transform", duration = 200.ms))
    }

    hover {
        Modifier.transform { rotate((-10).deg) }
    }
}

val SocialLinksStyle = CssStyle {
    base {
        Modifier
            .color(Theme.Primary.rgb) // Gold
            .transition(
                Transition.of(property = "color", duration = 200.ms),
                Transition.of(property = "transform", duration = 200.ms),
            )
    }
    hover {
        Modifier.color(Theme.Secondary.rgb) // White on hover
    }
}

@OptIn(ExperimentalComposeWebApi::class)
val MainButtonStyle = CssStyle {
    base {
        Modifier
            .minWidth(180.px)
            .transition(Transition.of(property = "transform", duration = 200.ms))
    }
    hover {
        Modifier.transform { scale(1.05) }
    }
}

@OptIn(ExperimentalComposeWebApi::class)
val MainImageStyle = CssStyle {
    base {
        Modifier.styleModifier {
            filter {
                grayscale(100.percent)
            }
        }
            .transition(Transition.of(property = "filter", duration = 200.ms))
    }
    hover {
        Modifier.styleModifier {
            filter {
                grayscale(0.percent)
            }
        }
    }
}
